import * as React from "react";

const VehicleIcon: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                d="M.75 3v15.75h2.367C3.451 20.04 4.611 21 6 21s2.549-.96 2.883-2.25h6.234C15.451 20.04 16.611 21 18 21s2.549-.96 2.883-2.25h2.367v-7.805l-.21-.234-4.5-4.5L18.304 6H14.25V3H.75zm1.5 1.5h10.5v12.75H8.883C8.549 15.96 7.389 15 6 15s-2.549.96-2.883 2.25H2.25V4.5zm12 3h3.422l4.078 4.079v5.671h-.867C20.549 15.96 19.389 15 18 15s-2.549.96-2.883 2.25h-.867V7.5zM6 16.5c.838 0 1.5.662 1.5 1.5s-.662 1.5-1.5 1.5-1.5-.662-1.5-1.5.662-1.5 1.5-1.5zm12 0c.838 0 1.5.662 1.5 1.5s-.662 1.5-1.5 1.5-1.5-.662-1.5-1.5.662-1.5 1.5-1.5z"
                fill="#000"
            />
        </svg>
    )
};
export default React.memo(VehicleIcon);
